let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hzrP3")).then(() => parcelRequire('k87gZ'));